import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Warning } from "@mui/icons-material";

const ConfirmacionDialog = ({
  open,
  onClose,
  onConfirm,
  titulo = "¿Confirmar acción?",
  nombre,
  mensaje,
  descripcion,
  textoConfirmar = "Confirmar",
  textoCancelar = "Cancelar",
  iconColor = "error",
  confirmColor = "error",
}) => {
  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontSize: "0.9rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Warning color={iconColor} sx={{ fontSize: "1.2rem" }} />
        {titulo}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {nombre
            ? descripcion || (
                <>
                  ¿Está seguro que desea eliminar el registro{" "}
                  <strong>"{nombre}"</strong>?{" "}
                  {mensaje || "Esta acción no se puede deshacer."}
                </>
              )
            : mensaje || "Esta acción no se puede deshacer."}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 1.5 }}>
        <Button
          size="small"
          onClick={onClose}
          color="secondary"
          variant="outlined"
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          {textoCancelar}
        </Button>
        <Button
          size="small"
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          {textoConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmacionDialog;
